import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/common/space.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/trade/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/trade/graph.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/marginly-app/src/components/trade/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Between","Title","AllAssetsLink","TradeDesktopRow"] */ "/app/packages/marginly-app/src/components/trade/trade.styled.ts");
